export enum EDevicePlatform {
  Web = "WEB",
  Pwa = "PWA",
  Android = "ANDROID",
  Ios = "IOS",
  Telegram = "TELEGRAM",
  WebSocket = "WEBSOCKET",
}

export interface ITrustedDevice {
  id: string;
  fingerprint: string;
  platform: EDevicePlatform;
  app_version: string | null;
  user_agent: string | null;
  ip_address: string | null;
  last_seen_at: string | null;
  expires_at: string;
  is_current: boolean;
  has_active_session: boolean;
  city_locator: string | null;
  title_locator: string | null;
  locator_pending: boolean;
}